import React from 'react';
import Producto from './extras/Producto';

const Productos = () => {
	return (
		<section className='productos' id='products'>
			<div className='productos__container'>
				<h2 className='productos__title'>Productos</h2>

				<div className='productos__items'>
					<Producto
						datos={{
							producto: '1.jpg',
							title: 'Cortadora de plasma CS 4800 PRO',
							area: '1220mm x 2400mm',
							precio: "COP $ 22'300.000",
						}}
					/>
					<Producto
						datos={{
							producto: '2.jpg',
							title: 'Cortadora de plasma CS 4300 L',
							area: '1220mm x 950mm ',
							precio: "COP $ 12'800.000",
						}}
					/>
					<Producto
						datos={{
							producto: '1.jpg',
							title: 'Mesa de corte CS 4800 PRO + FUENTE PLASMA',
							area: '1220mm x 2400mm',
							precio: "COP $ 34'800.000",
						}}
					/>
				</div>
			</div>
		</section>
	);
};

export default Productos;
